<div *ngIf="isLoading" class="screen_loader animate__animated absolute inset-0 z-[35] grid place-content-center bg-[#fafafa] opacity-65 dark:bg-[#060818]">
  <img class="ml-[5px] h-auto w-20 flex-none" src="/assets/images/loader.svg" alt="" />
</div>

<div *ngIf="billData && globalInfo">
  <div class="mb-6 flex flex-wrap items-center justify-center gap-4 lg:justify-end">
    <app-e-invoice-actions [bill]="billData"></app-e-invoice-actions>
    <button type="button" class="btn btn-info gap-2" (click)="openSendModal()">
      <icon-send />
      {{ "bills.send_mail" | translate }}
    </button>
    <button type="button" class="btn btn-primary gap-2" (click)="printBill()">
      <icon-printer />
      {{ "print" | translate }}
    </button>
    <button type="button" (click)="onDownloadBill()" class="btn btn-success gap-2" [disabled]="isLoadingDownload">
      <ng-container *ngIf="isLoadingDownload; else alternateTranslation">
        <span class="inline-block h-3 w-3 animate-ping rounded-full bg-white ltr:mr-4 rtl:ml-4"></span>
        {{ "downloading" | translate }}
      </ng-container>
      <ng-template #alternateTranslation> <icon-download /> {{ "download" | translate }} </ng-template>
    </button>
  </div>
  <div class="panel">
    <div class="flex flex-wrap justify-between gap-4 px-4">
      <div class="text-2xl font-semibold uppercase">{{ "invoice" | translate }} {{ billId }}</div>
      <div class="shrink-0">
        <img src="/assets/images/billlogo.png" alt="" class="ng-tns-c23-1 inline w-[90px] ltr:ml-auto rtl:mr-auto" />
      </div>
    </div>
    <div class="px-4 ltr:text-right rtl:text-left">
      <div class="mt-6 space-y-1 text-white-dark">
        <div class="text-black text-xl">Tourism Software Solutions</div>
        <div>{{ globalInfo.companyAddress }}</div>
        <div>{{ globalInfo.companyEmail }}</div>
        <div>{{ globalInfo.companyPhone }}</div>
        @if (billData.useIBAN) {
          <div>IBAN: {{ globalInfo.iban }}</div>
          <div>SWIFT (BIC): {{ globalInfo.swift }}</div>
        } @else {
          <div>{{ "account_number" | translate }}: {{ globalInfo.accountNumber }}</div>
        }
        <div>
          {{ "pin" | translate }}: {{ globalInfo.pib }} {{ "mb" | translate }}:
          {{ globalInfo.mb }}
        </div>
      </div>
    </div>

    <hr class="my-6 border-[#e0e6ed] dark:border-[#1b2e4b]" />
    <div class="flex flex-col flex-wrap justify-between gap-6 lg:flex-row">
      <div class="flex-1">
        <div class="space-y-1 text-white-dark">
          <div>{{ "issue_for" | translate }}</div>
          <div class="font-semibold text-black dark:text-white">
            {{ contractData?.customer?.companyName }}
          </div>
          <div>{{ contractData?.customer?.name }} {{ contractData?.customer?.surname }}</div>
          <div>{{ contractData?.customer?.address }}</div>
          <div>{{ contractData?.customer?.email }}</div>
          <div>{{ contractData?.customer?.phone }}</div>
          <div *ngIf="contractData?.customer?.pib && contractData?.customer?.mb">
            {{ "pin" | translate }}: {{ contractData?.customer?.pib }} {{ "mb" | translate }}:
            {{ contractData?.customer?.mb }}
          </div>
        </div>
      </div>
      <div class="flex flex-col justify-between gap-6 sm:flex-row lg:w-2/3">
        <div class="xl:1/3 sm:w-1/2 lg:w-2/5">
          <div class="mb-2 flex w-full items-center justify-between">
            <div class="text-white-dark">{{ "invoice" | translate }}:</div>
            <div>#{{ billData.id }}</div>
          </div>
          <div class="mb-2 flex w-full items-center justify-between">
            <div class="text-white-dark">{{ "issue_date" | translate }}:</div>
            <div>{{ billData.createdDate | date: "dd.MM.yyyy" }}</div>
          </div>
          <div class="mb-2 flex w-full items-center justify-between">
            <div class="text-white-dark">{{ "order_id" | translate }}:</div>
            <div>#{{ billData.id }}</div>
          </div>
          <div class="flex w-full items-center justify-between">
            <div class="text-white-dark">{{ "start_date" | translate }}:</div>
            <div>{{ billData.startDate | date: "dd.MM.yyyy" }}</div>
          </div>
          <div class="flex w-full items-center justify-between">
            <div class="text-white-dark">{{ "end_date" | translate }}:</div>
            <div>{{ billData.endDate | date: "dd.MM.yyyy" }}</div>
          </div>
        </div>
        <div class="xl:1/3 sm:w-1/2 lg:w-2/5">
          <div class="mb-2 flex w-full items-center justify-between">
            <div class="text-white-dark">{{ "country" | translate }}</div>
            <div>{{ "serbia" | translate }}</div>
          </div>
        </div>
      </div>
    </div>
    <hr class="my-6 border-[#e0e6ed] dark:border-[#1b2e4b]" />
    <div class="flex flex-col flex-wrap justify-between gap-6 lg:flex-row">
      <div class="flex w-full flex-col justify-between">
        <div class="text-white-dark">{{ "instructions" | translate }}</div>
        <div>
          {{ "instructions_text" | translate }}
        </div>
      </div>
    </div>
    <div class="table-responsive mt-6">
      <table class="table-striped">
        <thead>
          <tr>
            <th>{{ "title" | translate }}</th>
            <th>{{ "quantity" | translate }}</th>
            <th class="ltr:text-right rtl:text-left">
              {{ "price" | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ "billing.title" | translate }} {{ packageTitle }}</td>
            <td>1</td>
            <td class="ltr:text-right rtl:text-left">{{ billData.price }} €</td>
          </tr>
          <tr *ngIf="plansToPay > 0">
            <td>{{ "billing.plans_to_pay" | translate }}</td>
            <td>{{ plansToPay }}</td>
            <td class="ltr:text-right rtl:text-left">{{ plansToPay * 2 }} €</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-6 grid grid-cols-1 px-4 sm:grid-cols-2">
      <div></div>
      <div class="space-y-2 ltr:text-right rtl:text-left">
        <div class="flex items-center">
          <div class="flex-1">{{ "billing.exchange_rate" | translate }}</div>
          <div class="w-[37%]">{{ billData.exchangeRate | number: "1.4-4" }}</div>
        </div>
        <div class="flex items-center">
          <div class="flex-1">{{ "tax" | translate }}</div>
          <div class="w-[37%]">{{ tax | number: "1.1-1" }} €</div>
        </div>
        <div class="flex items-center">
          <div class="flex-1">{{ "shipping_rate" | translate }}</div>
          <div class="w-[37%]">0 €</div>
        </div>
        <div class="flex items-center">
          <div class="flex-1">{{ "discount" | translate }}</div>
          <div class="w-[37%]">0 €</div>
        </div>
        <div class="flex items-center text-lg font-semibold">
          <div class="flex-1">{{ "grand_total" | translate }}</div>
          <div class="w-[37%]">{{ total }} €</div>
        </div>
        <div class="flex items-center text-lg font-semibold" *ngIf="billData.currencyCode !== 'EUR'">
          <div class="flex-1">{{ "grand_total_in" | translate }} {{ billData.currencyCode }}</div>
          <div class="w-[37%]">{{ totalInRsd | number: "1.2-2" }} {{ billData.currencyCode | currencySymbol }}</div>
        </div>
      </div>
    </div>
    <p class="mt-4">Ovaj dokument je važeći bez potpisa i pečata</p>
  </div>
</div>

<ng-template #modalTemplate>
  <div class="flex flex-col p-4">
    <div class="space-y-5">
      <div class="mb-4">
        <p class="text-xl">{{ "contractsendemail.sendbill" | translate }}</p>
        <ng-content></ng-content>
        <div class="mb-4">
          <tag-input
            [(ngModel)]="emails"
            [modelAsStrings]="true"
            [placeholder]="'contractsendemail.email_to_send' | translate"
            [secondaryPlaceholder]="'contractsendemail.email_to_send' | translate"
            [maxItems]="4"
            [blinkIfDupe]="true"
            [validators]="validators"
            [trimTags]="true"
            [errorMessages]="errorMessages"
          ></tag-input>
          <p>{{ "contractsendemail.email_hint" | translate }}</p>
        </div>
      </div>
      <form [formGroup]="form" (submit)="sendBill()" class="flex items-center justify-center gap-5">
        <button data-cy="send-button" type="submit" class="btn btn-primary w-30 h-10" [disabled]="isLoadingSend">
          <ng-container *ngIf="isLoadingSend; else alternateTranslation">
            <span class="inline-block h-3 w-3 animate-ping rounded-full bg-white ltr:mr-4 rtl:ml-4"></span>
            {{ "loading" | translate }}
          </ng-container>
          <ng-template #alternateTranslation>
            {{ "send" | translate }}
          </ng-template>
        </button>
      </form>
    </div>
  </div>
</ng-template>
